import axios from 'axios';

// const baseUrl = process.env.REACT_APP_API_URL;
const baseUrl = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
  baseURL: baseUrl,
});

axiosInstance.interceptors.request.use(
  config => {
    config.headers['x-access-token'] = process.env.REACT_APP_API_KEY;
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export const getFactures = async condition => {
  const response = await axiosInstance.get(`${baseUrl}/facturation/factures`, {
    params: condition,
  });
  return response.data;
};

export const getVentes = async condition => {
  const response = await axiosInstance.get(`${baseUrl}/facturation/ventes`, {
    params: condition,
  });
  return response.data;
};

export const getDetailsVentes = async condition => {
  const response = await axiosInstance.get(`${baseUrl}/facturation/details-ventes`, {
    params: condition,
  });

  return response.data;
};

export const getMagasins = async condition => {
  const response = await axiosInstance.get(`${baseUrl}/facturation/magasin`, {
    params: condition,
  });
  return response.data;
};

export const getFacture = async condition => {
  const response = await axiosInstance.get(`${baseUrl}/facturation/facture`, {
    params: condition,
  });
  return response.data;
};

export const getDetailsFacture = async condition => {
  const response = await axiosInstance.get(`${baseUrl}/facturation/details-facture`, {
    params: condition,
  });
  return response.data;
};
